import { ActionButton } from '../ActionButton/ActionButton';

/**
 * {@docCategory Button}
 */
export const CommandButton = ActionButton;



// WEBPACK FOOTER //
// ../src/components/Button/CommandButton/CommandButton.tsx